import Ajax from '@utils/ajax';

export default {
  signInGoogle(data, options = {}) {
    return Ajax.post({
      url: `/oauth/google`,
      data: { data: data },
      ...options,
    });
  },

  signInFacebook(data, options = {}) {
    return Ajax.post({
      url: `/oauth/facebook`,
      data: { data: data },
      ...options,
    });
  },
};
